import { TComplexSectionData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { Title } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/title/Title'
import { useCallback } from 'react'

import { MultiInputsControl } from 'partner360/components/multiInputsControl'

import styles from './MultiInputWithTitle.module.scss'

interface IMultiInputWithTitleProps {
  data: string[]
  updateFormData: (data: TComplexSectionData) => void
  titleText: string
  withDot?: boolean
}

export const MultiInputWithTitle = ({
  data,
  titleText,
  updateFormData,
  withDot,
}: IMultiInputWithTitleProps) => {
  return (
    <div>
      <Title variant="withBackground" text={titleText} />

      <MultiInputsControl
        values={data}
        withDot={withDot}
        onChange={updateFormData}
        placeholder={getFormedEltTranslation('enter-value')}
      />
    </div>
  )
}
